import React from 'react'
import styled from 'styled-components'
import { IGatsbyChildImageSharp, IGatsbyImageDataObject } from '@et/types/Gatsby'
import GatsbyImgSmall from '@components/imageModules/v3/gatsbyImgSmall'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import BackgroundImageV5 from '../v5/backgroundImg_v5'

interface IPadImgProps {
  img: IGatsbyImageDataObject // v3 image
  iPadImg: IGatsbyImageDataObject // v2 image for bg
  alt: string
}

function IPadImgv4Small(props: IPadImgProps) {
  const { img, iPadImg, alt } = props

  return (
    <ImgContainer>
      <BackgroundImageV5
        containerClasses='rounded-xl overflow-hidden'
        gatsbyDataImg={iPadImg.gatsbyImageData}
        disableMinHeight={true}>
        <Screen>
          <GatsbyImage alt={alt} image={img.gatsbyImageData} loading={GATSBYIMGLOADING.LAZY} />
        </Screen>
      </BackgroundImageV5>
    </ImgContainer>
  )
}

const Screen = styled.div`
    position: relative;
    padding: 13px 13px 15px;
    z-Index: 2;
`
const ImgContainer = styled.div`
    max-width: 300px;
    margin: 0 auto;

  .gatsby-image-wrapper {
    &:after, &:before{
      top: -8px;
      background-size: 100% !important;
      background-repeat: no-repeat !important;
    }
  }
`
export default IPadImgv4Small
